import React, { useContext } from 'react';
import { recentUsersColumns } from 'components/DataTable/columns/recentUsersColumns';
import DataTableStatusWrapper from 'components/DataTable/DataTableStatusWrapper';
import NoDataComponent from 'components/DataTable/NoDataComponent';
import RecentUsersTable from 'views/RecentUsersPage/RecentUsersTable';
import { RecentUsersContext } from 'contexts/recentUsers.context';
import { RecentUsersHeader } from './RecentUsersHeader';
import useRecentUsers from './RecentUsersHook';
import HeaderDefault from 'components/Header/HeaderDefault';

export default function RecentUsersTableContainer() {
  const {
    usersList,
    networkError,
    searchTerm,
    selectedSearchMenuOptionLabel,
    isLoading,
    isSorting,
    totalCount,
  } = useContext(RecentUsersContext);
  const { SortHandler, SearchHandler } = useRecentUsers();

  let emptyText = <>No users to display</>;
  if (searchTerm !== '') {
    emptyText = (
      <>
        Sorry, no results were found for {searchTerm}
        {selectedSearchMenuOptionLabel !== '' && (
          <>
            &nbsp;in <b>{selectedSearchMenuOptionLabel}</b>
          </>
        )}
      </>
    );
  }

  return (
    <>
      <HeaderDefault itemCount={totalCount} CountTitle='Total User' />
      <RecentUsersHeader SearchHandler={SearchHandler} />
      <main>
        <div className="container">
          <>
            <DataTableStatusWrapper
              error={networkError}
              status={isLoading && !isSorting ? 'loading' : ''}
            >
              <RecentUsersTable
                columns={recentUsersColumns}
                data={usersList}
                defaultSortFieldId="last_seen"
                handleSort={SortHandler}
                noDataComponent={<NoDataComponent text={emptyText} />}
              />
            </DataTableStatusWrapper>
          </>
        </div>
      </main>
    </>
  );
}
